<div class="duplication-merger-dialog">

  <div class="dialog-title">
    <h3>Merge {{ modulePassedIn?.name | titlecase }} Records</h3>
    <div class="desc">
      Choose a primary record, then click values from duplicates to merge them in. Activities, documents, and subs will transfer automatically.
    </div>
  </div>

  <div class="dialog-body">
    @if (retrievingRecords) {
      <app-loading-overlay></app-loading-overlay>
    }

    @if (!retrievingRecords) {
      <div class="merge-wrapper">
        <table class="record-table">
          <thead>
            <th class="field-label-col">&nbsp;</th>
            <th class="primary-col">
              <div class="primary-col-header">
                <mat-icon class="primary-icon">star</mat-icon>
                <div>
                  <div class="col-header-label">Primary Record</div>
                  <div class="col-header-name">{{ primaryRecord?.name | titlecase }}</div>
                </div>
              </div>
            </th>
            @for (_record of chosenRecords; track _record; let i = $index) {
              <th class="dup-col">
                <div class="dup-col-header">
                  <mat-radio-button matTooltip="Set as Primary Record" color="primary" [checked]="masterRecordIndex === i" (change)="setPrimaryRecord(i)">
                    <div>
                      <div class="col-header-label">Duplicate</div>
                      <div class="col-header-name">{{ _record?.name | titlecase }}</div>
                    </div>
                  </mat-radio-button>
                  <div class="remove-record" matTooltip="Remove from merge" (click)="removeRecord(i)">
                    <mat-icon>close</mat-icon>
                  </div>
                </div>
              </th>
            }
          </thead>
          <tbody>
            @for (_field of fields; track _field) {
              <tr [class.diff-row]="differingFields[_field.fieldName]" [class.same-row]="!differingFields[_field.fieldName]">
                <td class="field-label-col">
                  <div class="field-label" [matTooltip]="_field.label">{{ _field.label }}</div>
                </td>
                <td class="primary-col">
                  @if (primaryRecord) {
                    <div class="field-value primary-value" [class.was-picked]="pickedFields[_field.fieldName]">
                      <field-type-edit [fieldPassedIn]="_field" [recordPassedIn]="primaryRecord" [hideLabels]="true"></field-type-edit>
                      @if (pickedFields[_field.fieldName]) {
                        <mat-icon class="picked-check">check_circle</mat-icon>
                      }
                    </div>
                  }
                </td>
                @for (_record of chosenRecords; track _record; let i = $index) {
                  <td class="dup-col">
                    @if (fieldToIndexMapping) {
                      <div class="field-value dup-value" [class.is-source]="pickedFields[_field.fieldName] === i" matTooltip="Use this value" (click)="setPrimaryFromField(i, _field.fieldName)">
                        <field-type-edit [fieldPassedIn]="_field" [recordPassedIn]="_record" [hideLabels]="true" [disabled]="true"></field-type-edit>
                        <mat-icon class="use-value-icon">arrow_back</mat-icon>
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="action-buttons">
    <button mat-stroked-button mat-dialog-close (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="saveMerge()">Save Merge</button>
  </div>
</div>
